var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeRing501(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 209,
    viewBox: "0 0 206 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_153_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5133 67.3816C56.4904 61.816 63.5051 57.4821 71.157 54.6274C78.809 51.7728 86.9482 50.4532 95.1101 50.7441C103.272 51.035 111.297 52.9307 118.726 56.3229C126.155 59.715 132.844 64.5373 138.409 70.5144C143.975 76.4914 148.309 83.5061 151.164 91.1581C154.018 98.81 155.338 106.949 155.047 115.111C154.756 123.273 152.86 131.298 149.468 138.727C146.076 146.156 141.254 152.845 135.277 158.41L108.31 129.45C110.483 127.426 112.237 124.993 113.471 122.291C114.705 119.589 115.394 116.67 115.5 113.702C115.606 110.733 115.126 107.773 114.088 104.99C113.05 102.207 111.473 99.6553 109.449 97.4814C107.425 95.3074 104.992 93.5535 102.29 92.3198C99.5879 91.086 96.6692 90.3965 93.7006 90.2907C90.7321 90.1849 87.7717 90.6649 84.9887 91.7031C82.2056 92.7414 79.6542 94.3177 77.4803 96.3419L50.5133 67.3816Z",
    fill: "#FFBA68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_153_42",
    x: 0.513306,
    y: 0.704651,
    width: 204.573,
    height: 207.706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_153_42"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRing501);
export default __webpack_public_path__ + "static/media/orange-ring50-1.6f17cf82c082e4377c5337144b1e1979.svg";
export { ForwardRef as ReactComponent };